export default "__VITE_ASSET__eb36a4fb__"